import { ChatMessage } from '../../domain/messages/models/ChatMessage';

export const chunkMessages = (messages: ChatMessage[], chunkSize: number): ChatMessage[][] => {
    const chunks: ChatMessage[][] = [];
    for (let i = 0; i < messages.length; i += chunkSize) {
        chunks.push(messages.slice(i, i + chunkSize));
    }
    return chunks;
};
